import React, { useState, useEffect, useCallback } from "react";
import { Container, Row, Col } from "react-bootstrap";
import IDSTable from "./IDSTable";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Alert from "react-bootstrap/Alert";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import Accordion from "react-bootstrap/Accordion";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { conditionsHeadCells } from "../util/headcells-util";
import { ERROR_MSG } from "../services/Constants";
import { S3_URL } from "../services/Constants";
import _ from "lodash";
import { fetchConditions } from "../services/conditions-service";

import {
  fetchConditionData,
  addNewCondition,
  fetchConditionById,
  updateConditionRecord,
  removeConditionRecord,
} from "../services/conditions-service";
import { handleIsActive } from "../util/common";
import { fetchCodeSetTable } from "../services/referenceTable-service";
import { useContext } from "react";
import UserContext from "../context/user-context";
import { componentIsVisible, validateAndSanitizeUrl } from "../util/common";
import { CTRB, CTUB } from "../util/component-codes";
import Cookies from "js-cookie";
import { FixedSizeList } from "react-window";

const Conditions = () => {
  const [show, setShow] = useState(false);

  const [showRemoveWarningModal, setShowRemoveWarningModal] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);

  const [form, setForm] = useState({});
  const [alertMessage, setAlertMessage] = useState();
  const [filter, setFilter] = useState({});
  const [isAddNew, setIsAddNew] = useState(false);

  const [validated, setValidated] = useState(false);
  const [isAdded, setIsAdded] = useState(false);
  const [isUpdated, setIsUpdated] = useState(false);
  const [isDeleted, setIsDeleted] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [conditionData, setConditionData] = useState(null);
  const [recordsPerPage, setRecordsPerPage] = useState(
    Cookies.get("itemsPerPage") ? Cookies.get("itemsPerPage") : 5
  );
  const [pageNo, setPageNo] = useState(0);
  const [isFetchError, setIsFetchError] = useState(false);
  const [isError, setIsError] = useState(false);
  const [programAreaValues, setProgramAreaValues] = useState([]);
  const [programAreaCheckedValues, setProgramAreaCheckedValues] = useState([]);
  const [conditions, setConditions] = useState([]);


  const handleClose = () => setShow(false);
  const handleRemoveWarningModalClose = () => setShowRemoveWarningModal(false);
  const handleFilterModalClose = () => setShowFilterModal(false);

  const [user] = useContext(UserContext);

  const urlWithParams = (filter) => {
    let conditionName = filter?.searchText ? filter?.searchText : "";
    let programArea =
      filter?.programArea?.length > 0 ? filter?.programArea : [];
    let isActive = [];

    if (filter?.active) {
      isActive.push("true");
    }
    if (filter?.inactive) {
      isActive.push("false");
    }

    let params = "";

    if (conditionName !== "") {
      params += `&conditionName=${conditionName}`;
    }
    if (programArea.length > 0) {
      params += `&programArea=${programArea.toString()}`;
    }
    if (isActive.length > 0) {
      params += `&isActive=${isActive.toString()}`;
    }

    return params;
  };

  const handleProgramAreaCheckboxChange = (event) => {
    let copyCheckedValues = [...programAreaCheckedValues];

    if (copyCheckedValues.includes(event.target.name)) {
      copyCheckedValues = copyCheckedValues.filter(
        (item) => item !== event.target.name
      );
    } else {
      copyCheckedValues = [...copyCheckedValues, event.target.name];
    }
    setProgramAreaCheckedValues(copyCheckedValues);
    setFilterField("programArea", copyCheckedValues);
  };

  const getConditionData = useCallback(
    async (filter, conditions) => {
      let response = await fetchConditionData(
        pageNo,
        recordsPerPage,
        urlWithParams(filter)
      );

      if (response.ok) {
        let data = await response.json();
        if (data.genericList != null) {
          data.genericList.forEach((item) => {
            item.parentCondition = conditions.find(
              (item1) => item1.conditionId == item.parentConditionId
            )?.conditionName;
          });
          setConditionData(data);
        } else {
          setIsFetchError(true);
          let error = await response.json();
          setIsError(true);
          setAlertMessage(error?.description);
        }
      } else {
        setIsFetchError(true);
        let error = await response.json();
        setIsError(true);
        setAlertMessage(error?.description);
      }
    },
    [pageNo, recordsPerPage]
  );

  const addCondition = async () => {
    let newForm = {
      ...form,
      conditionName: form?.conditionName?.trim(),
      eventCode: form?.eventCode ? form.eventCode.trim() : null,
      diseaseKey: form?.diseaseKey ? form.diseaseKey.trim() : null,
    };
    let data = await addNewCondition(newForm);
    if (data.conditionId != null) {
      setIsAdded(true);
      setShow(false);

    } else {
      setIsError(true);
      setAlertMessage(data?.description);
    }
  };

  const updateCondition = async () => {
    let newForm = {
      ...form,
      conditionName: form?.conditionName?.trim(),
      eventCode: form?.eventCode ? form.eventCode.trim() : null,
      diseaseKey: form?.diseaseKey ? form.diseaseKey.trim() : null,
    };
    let data = await updateConditionRecord(newForm);
    if (data.conditionId != null) {
      setSelectedRow(data);
      setIsUpdated(true);
      setShow(false);

    } else {
      setIsError(true);
      setAlertMessage(data?.description);
    }
  };

  const removeCondition = async () => {
    let response = await removeConditionRecord(selectedRow.conditionId);
    if (response !== ERROR_MSG) {
      setIsDeleted(true);
      setSelectedRow(null);
    } else {
      setIsError(true);
    }
    handleRemoveWarningModalClose();
  };

  const getConditions = async () => {
    let response = await fetchConditions();
    if (response.ok) {
      let data = await response.json();
      if (data?.length > 0) {
        setConditions(data);
      } else {
        setAlertMessage(data?.description);
      }
    } else {
      let error = await response.json();
      setAlertMessage(error?.description);
    }
  };
  
  const getProgramAreaValues = async () => {
    let response = await fetchCodeSetTable("Program Area");
    if (response.ok) {
      let data = await response.json();
      setProgramAreaValues(data?.refTableValues);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        await getConditionData(filter, conditions);
      } catch (error) {
        console.error('Error fetching condition data:', error);
      }
    };
  
    conditions.length>0 && fetchData();
  }, [pageNo, recordsPerPage, getConditionData, conditions]);
  
  useEffect(() => {
    const fetchData = async () => {
      if (isAdded || isUpdated || isDeleted) {
        try {
          await getConditionData(filter, conditions);
        } catch (error) {
          console.error('Error fetching condition data:', error);
        }
      }
    };
  
    conditions.length>0 && fetchData();
  }, [isAdded, isUpdated, isDeleted, getConditionData, conditions]);
  
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        await getConditions();
        await getProgramAreaValues();
      } catch (error) {
        console.error('Error fetching initial data:', error);
      }
    };
  
    fetchInitialData();
  }, []);

  useEffect(() => {
    if (pageNo >= conditionData?.totalPages) {
      conditionData?.totalPages !== 0 &&
        setPageNo(conditionData?.totalPages - 1);
    }
  }, [conditionData]);

  const setField = (field, value) => {
    setForm({
      ...form,
      [field]: value,
    });
  };

  const setFilterField = (field, value) => {
    setFilter({
      ...filter,
      [field]: value,
    });
  };

  const handleAdd = () => {
    setForm({});
    setValidated(false);
    setIsAddNew(true);
    setShow(true);
    setIsAdded(false);
    setIsUpdated(false);
    setIsDeleted(false);
    setIsError(false);
  };

  const handleShowFilter = () => {
    setIsAdded(false);
    setIsUpdated(false);
    setIsDeleted(false);
    setIsError(false);
    setShowFilterModal(true);
  };

  const handleUpdate = async () => {
    let response = await fetchConditionById(selectedRow.conditionId);
    if (response.ok) {
      let data = await response.json();
      if (data != null) {
        setForm(data);
        setValidated(false);
        setIsAddNew(false);
        setShow(true);
        setIsUpdated(false);
        setIsAdded(false);
        setIsDeleted(false);
        setIsError(false);
      }
    } else {
      let error = await response.json();
      setIsError(true);
      setAlertMessage(error?.description);
    }
  };

  const handleRemove = () => {
    setShowRemoveWarningModal(true);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setValidated(true);
    if (event.currentTarget.checkValidity() === true) {
      isAddNew ? addCondition() : updateCondition();
    }
  };

  const handleFilter = (event) => {
    event.preventDefault();
    setPageNo(0);
    pageNo === 0 && conditions.length>0 && getConditionData(filter, conditions);
    handleFilterModalClose();
  };

  const handleResetFilter = () => {
    setProgramAreaCheckedValues([]);
    setFilter({});
  };

  const setSelectedRowCallback = (row) => {
    setSelectedRow(row);
  };

  const setRecordsPerPageCallback = (value) => {
    setRecordsPerPage(value);
  };

  const setPageNoCallback = (value) => {
    setPageNo(value);
  };

  const buttonsLayout = () => {
    return (
      <div className="flexCenter">
        {componentIsVisible(CTUB, user) && (
          <Button
            className="updateButtonStyle generalFont flexCenter"
            onClick={handleUpdate}
            disabled={selectedRow === null}
          >
            <img
              src={`${validateAndSanitizeUrl(S3_URL)}update-icon.png`}
              className="buttonIcon"
              alt=""
            ></img>
            Update
          </Button>
        )}
        {componentIsVisible(CTRB, user) && (
          <Button
            className="removeButtonStyle generalFont flexCenter"
            onClick={handleRemove}
            disabled={selectedRow === null}
          >
            <img
              src={`${validateAndSanitizeUrl(S3_URL)}delete-icon.png`}
              className="buttonIcon"
              alt=""
            ></img>
            Remove
          </Button>
        )}
      </div>
    );
  };

  const renderBannerMessage = () => {
    if (isDeleted) {
      return "Successfully deleted Condition record";
    } else if (isAdded) {
      return "New Condition has been successfully added!";
    } else if (isUpdated) {
      return "Condition has been successfully updated!";
    } else if (isError) {
      return alertMessage
        ? alertMessage
        : "Something went wrong, please try again";
    }
  };

  const setExpandedAccordion = () => {
    let active = [];
    if (programAreaCheckedValues.length > 0) {
      active.push("0");
    }
    if (filter?.active || filter?.inactive) {
      active.push("1");
    }
    return active;
  };

  return (
    <>
      <Container fluid className="loincContainer">
        <Row style={{ marginLeft: "0px" }}>
          <Col xl={8}>
            <Row className="tableTitle generalFont">Condition Table</Row>
            <Row className="tableSubtitle generalFont">
              View all the conditions registered within the rules engine
            </Row>
          </Col>
        </Row>
        {(isAdded || isUpdated || isDeleted || isError) && (
          <Alert
            style={{ marginRight: "125px" }}
            key={"success"}
            variant={isError ? "danger" : "success"}
            onClose={() => {
              setIsAdded(false);
              setIsUpdated(false);
              setIsDeleted(false);
              setIsError(false);
            }}
            dismissible
          >
            {renderBannerMessage()}
          </Alert>
        )}
        <IDSTable
          isFetchError={isFetchError}
          setPageNoCallback={setPageNoCallback}
          setRecordsPerPageCallback={setRecordsPerPageCallback}
          headCells={conditionsHeadCells}
          rows={conditionData?.genericList}
          pages={conditionData?.totalPages}
          buttonsLayout={buttonsLayout}
          addButtonName="Add New Condition"
          addButtonAction={handleAdd}
          closeButtonAction={handleClose}
          setSelectedRowCallback={setSelectedRowCallback}
          handleShowFilter={handleShowFilter}
          isConditionTable={true}
        />
      </Container>
      <Modal show={show} onHide={handleClose} size="lg" centered>
        <Form onSubmit={handleSubmit} noValidate validated={validated}>
          <Modal.Header className="modalHeaderContainer" closeButton>
            <Modal.Title className="modalHeader generalFont">
              {isAddNew ? "Add New Condition" : "Update Condition"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="modalBodyContainer">
            <Row>
              {isError && 
                <Alert
                  style={{ marginRight: "125px" }}
                  key={"error"}
                  variant={"danger"}
                  dismissible
                  onClose={() => {
                    setIsError(false);
                  }}
                >
                  {renderBannerMessage()}
                </Alert>
              }
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="form.conditionName">
                  <React.Fragment>
                    <Form.Label className="modalLabel generalFont">
                      Condition Name <i className="text-danger">(required)</i>
                    </Form.Label>
                  </React.Fragment>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    placeholder="Hint Text"
                    required
                    value={form.conditionName}
                    onChange={(e) => setField("conditionName", e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Col>
                  <Form.Group className="mb-3" controlId="form.programArea">
                    <Form.Label className="modalLabel generalFont">
                      Program Area
                    </Form.Label>
                    <Form.Select
                      className="modalInput generalFont"
                      aria-label="Choose Item"
                      value={form.programArea}
                      onChange={(e) => setField("programArea", e.target.value)}
                    >
                      <option value="">Choose Item</option>
                      {_.sortBy(programAreaValues, [
                        "reference_Code_description",
                      ]).map((entry) => {
                        return (
                          <option
                            key={entry.referenceTableValueId}
                            value={entry.reference_Code_description}
                          >
                            {entry.reference_Code_description}
                          </option>
                        );
                      })}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Col>
            </Row><Row>
              <Col>
                <Form.Group className="mb-3" controlId="form.conditionName">
                  <React.Fragment>
                    <Form.Label className="modalLabel generalFont">
                      Event Code
                    </Form.Label>
                  </React.Fragment>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    placeholder="Hint Text"
                    value={form.eventCode}
                    maxLength={50}
                    onChange={(e) => setField("eventCode", e.target.value)}
                  />
                  <Form.Control.Feedback type="invalid">
                      Event Code cannot exceed 50 characters
                   </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col>
                <Col>
                  <Form.Group className="mb-3" controlId="form.programArea">
                    <Form.Label className="modalLabel generalFont">
                      Disease Key <i className="text-danger">(required)</i>
                    </Form.Label>
                    <Form.Control
                      className="modalInput generalFont"
                      type="text"
                      placeholder="Hint Text"
                      required
                      maxLength={50}
                      value={form.diseaseKey}
                      onChange={(e) => setField("diseaseKey", e.target.value)}
                   />
                   <Form.Control.Feedback type="invalid">
                      Disease Key cannot exceed 50 characters
                   </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="form.isActive">
                  <Form.Label className="modalLabel generalFont">
                    Status <i className="text-danger">(required)</i>
                  </Form.Label>
                  <Form.Select
                    className="modalInput generalFont"
                    aria-label="Choose Item"
                    required
                    value={handleIsActive(form.isActive)}
                    onChange={(e) =>
                      setField(
                        "isActive",
                        e.target.value === "Active" ? true : false
                      )
                    }
                  >
                    <option hidden value="">
                      Choose Item
                    </option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="form.conditionId">
                  <Form.Label className="modalLabel generalFont">
                    Parent Condition{" "}
                  </Form.Label>
                  <Form.Select
                    className="modalInput generalFont"
                    aria-label="Choose Item"
                    value={form?.parentConditionId}
                    onChange={(e) =>
                      setField("parentConditionId", e.target.value)
                    }
                  >
                    <option value="">
                      Choose Item
                    </option>
                    {_.sortBy(conditions, ["conditionName"])
                      .filter((item) => item?.conditionId !== form?.conditionId)
                      .map((entry) => {
                        return (
                          <option
                            key={entry.conditionId}
                            value={entry.conditionId}
                          >
                            {entry.conditionName}
                          </option>
                        );
                      })}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <Form.Group className="mb-3" controlId="form.comments">
              <Form.Label className="modalLabel generalFont">
                Admin Comments
              </Form.Label>
              <Form.Control
                className="modalInput generalFont"
                as="textarea"
                rows={3}
                value={form.comments}
                onChange={(e) => setField("comments", e.target.value)}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer className="modalFooterContainer">
            <Button
              type="submit"
              className="modalAddUpdateStyle generalFont flexCenter"
            >
              <img
                src={`${validateAndSanitizeUrl(S3_URL)}plus-icon.png`}
                alt=""
                style={{ marginRight: "10px" }}
              ></img>
              {isAddNew ? "Add" : "Update"}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <Modal
        show={showRemoveWarningModal}
        onHide={handleRemoveWarningModalClose}
        size="lg"
        centered
      >
        <Modal.Header className="modalHeaderContainer" closeButton>
          <Modal.Title className="modalHeader generalFont">
            Remove Condition
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBodyContainer">
          <React.Fragment>
            <Form.Label className="modalLabel generalFont">
              Are you sure you want to remove this condition from the Table?
            </Form.Label>
          </React.Fragment>
        </Modal.Body>
        <Modal.Footer className="modalFooterContainer">
          <Button
            onClick={handleRemoveWarningModalClose}
            className="modalCancelStyle generalFont flexCenter"
            variant="secondary"
          >
            Cancel
          </Button>
          <Button
            onClick={removeCondition}
            className="modalRemoveStyle generalFont flexCenter"
          >
            Remove
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showFilterModal}
        onHide={handleFilterModalClose}
        size="sm"
        centered
        dialogClassName="my-modal-30"
      >
        <Modal.Header className="modalHeaderContainer" closeButton>
          <Modal.Title className="modalHeader generalFont">
            Apply Filters
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBodyContainer">
          <React.Fragment>
            <Form.Label className="modalLabel generalFont">
              <TextField
                className="my-modal-searchbox-30"
                size="small"
                placeholder="Search condition"
                value={filter.searchText ? filter.searchText : ""}
                onChange={(e) => setFilterField("searchText", e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      <img
                        src={`${validateAndSanitizeUrl(S3_URL)}search-icon.png`}
                        alt=""
                        style={{ height: "19px", width: "19px" }}
                      ></img>
                    </InputAdornment>
                  ),
                }}
              />
            </Form.Label>
            <br />
            <br />
            <Accordion
              alwaysOpen
              disablegutters="true"
              defaultActiveKey={setExpandedAccordion()}
            >
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <div className="bold">Program Area</div>
                </Accordion.Header>
                <Accordion.Body>
                  <FormGroup>
                    <FixedSizeList
                      height={200}
                      itemSize={40}
                      itemCount={
                        programAreaValues.sort((a, b) =>
                          a.reference_Code_description.localeCompare(
                            b.reference_Code_description
                          )
                        ).length
                      }
                    >
                      {({ index, style }) => (
                        <div style={style}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={programAreaCheckedValues.includes(
                                  programAreaValues[index]
                                    .reference_Code_description
                                )}
                                onChange={handleProgramAreaCheckboxChange}
                                name={
                                  programAreaValues[index]
                                    .reference_Code_description
                                }
                              />
                            }
                            label={
                              programAreaValues[index]
                                .reference_Code_description
                            }
                          />
                        </div>
                      )}
                    </FixedSizeList>
                  </FormGroup>
                </Accordion.Body>
              </Accordion.Item>
              <br />
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  <div className="bold">Status</div>
                </Accordion.Header>
                <Accordion.Body>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox />}
                      label="Active"
                      checked={filter.active ? true : false}
                      onChange={(e) =>
                        setFilterField("active", e.target.checked)
                      }
                    />
                    <FormControlLabel
                      control={<Checkbox />}
                      label="Inactive"
                      checked={filter.inactive ? true : false}
                      onChange={(e) =>
                        setFilterField("inactive", e.target.checked)
                      }
                    />
                  </FormGroup>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
            {/* </Form.Label> */}
          </React.Fragment>
        </Modal.Body>
        <Modal.Footer
          className="modalFooterContainer"
          style={{ justifyContent: "space-between", marginLeft: "23px" }}
        >
          <Button
            onClick={handleResetFilter}
            className="modalAddUpdateStyle generalFont flexCenter modalRemoveStyle"
          >
            Reset
          </Button>
          <Button
            onClick={handleFilter}
            className="modalAddUpdateStyle generalFont flexCenter"
          >
            Filter
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Conditions;
